<script setup lang="ts">
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { T } from '@tolgee/vue'
import BaseButton from '@/components/base/BaseButton.vue'
import GamepadIcon from '@/assets/images/challenges/joystick-icon.webp'
import PlayIcon from '@/assets/images/challenges/play-icon.webp'
import NavbarMoneyImage from '@/components/navbar-icons/NavbarMoneyImage.vue'

defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  hide: []
}>()

function handleClose() {
  emit('hide')
}
</script>

<template>
  <TheBottomSheet
    :show="show"
    wrapper-class="z-[801]"
    :centered="true"
    @hide="handleClose"
  >
    <div class="w-full flex flex-col gap-y-3">
      <h2 class="text-solid-white text-lg font-bold mb-1">
        <T
          key-name="minesweeper_challenge.rules.title"
          default-value="How it works?"
        />
      </h2>

      <div class="flex gap-x-4">
        <div class="flex-shrink-0">
          <img
            :src="GamepadIcon"
            class="size-6"
            alt="Game controller"
          >
        </div>
        <div class="flex flex-col gap-y-1">
          <p class="text-base font-medium text-white/60 leading-tight">
            <span class="text-white/[0.87] font-medium">
              <T
                key-name="minesweeper_challenge.rules.solve_quickly.title"
                default-value="Clear the grid"
              />
            </span>
            <T
              key-name="minesweeper_challenge.rules.solve_quickly.description"
              default-value=" without hitting mines as quickly as you can. Rankings are based on time."
            />
          </p>
        </div>
      </div>

      <div class="flex gap-x-4">
        <img
          :src="PlayIcon"
          class="size-6"
          alt="Play"
        >
        <div class="flex flex-col gap-y-1">
          <p class="text-base font-medium text-white/60 leading-tight">
            <span class="text-white/[0.87] font-medium">
              <T
                key-name="minesweeper_challenge.rules.replay.title"
                default-value="Replay"
              />
            </span>
            <T
              key-name="minesweeper_challenge.rules.replay.description"
              default-value=" to beat your best time and climb higher."
            />
          </p>
        </div>
      </div>

      <div class="flex gap-x-4">
        <div class="flex-shrink-0">
          <NavbarMoneyImage class="size-6" />
        </div>
        <div class="flex flex-col gap-y-1">
          <p class="text-base font-medium text-white/60 leading-tight">
            <span class="text-white/[0.87] font-medium">
              <T
                key-name="minesweeper_challenge.rules.wallet.title"
                default-value="Only"
              />
            </span>
            <T
              key-name="minesweeper_challenge.rules.wallet.description"
              default-value=" connected wallets will receive rewards."
            />
          </p>
        </div>
      </div>

      <BaseButton
        class="w-full mt-3"
        style-type="secondary"
        button-class="h-14 text-lg font-bold uppercase tracking-wider"
        @click="handleClose"
      >
        <T
          key-name="minesweeper_challenge.rules.got_it"
          default-value="GOT IT"
        />
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>

<style scoped lang="scss">
</style>